export const canIdentifyContact = queryParams => Boolean(queryParams.ecid || queryParams._hsenc);